var BusinessReport = (function () {

    var device;

    var init = function() {

        if (!$('#bel-activity-2016').length) return;

        // transmission device pour js
        device = window.getComputedStyle(document.getElementById('responsive_stat'), ':before').getPropertyValue('content');
        device = device.replace('"', '').replace('"', '');

        if(window.location.hash != ''){
            var url = window.location.hash;
            var cibleobject = $('a[data-url="'+url+'"]');
            if(cibleobject.length!=0){
                var cible = cibleobject.attr('href');
                var rcible = cibleobject.data('url-return');
                var tcible = cibleobject.data('tablet');
                var mcible = cibleobject.data('mobile');
                var dlcible = cibleobject.data('dl');
                launchUrlPopup(cible, url, tcible, mcible, rcible, dlcible);
            }
        }
        $('.slider li img').each(function(){

            if(device!='mobile'){
                if(device=='tablet'){
                    $(this).attr('src', $(this).data('tablet'));
                }
                if(device=='desktop'){
                    $(this).attr('src', $(this).data('desktop'));
                }
            }

        }).promise().done(function() {
            setTimeout(function(){
                $('.slider').bxSlider({
                    nextText : '<span class="bicon bicon-right"></span>',
                    prevText : '<span class="bicon bicon-left"></span>',
                });
            }, 1000);
        });


        // load vector sprite in html page
        $('#svg_container').load("/wp-content/themes/bel/acti2016/en/img/vector_sprite.svg");

        $('.pop').click(function(e){

            var cible = $(this).attr('href');
            var url = $(this).data('url');
            var rcible = $(this).data('url-return');
            var tcible = $(this).data('tablet');
            var mcible = $(this).data('mobile');
            var dlcible = $(this).data('dl');
            window.location.hash = url;

            launchUrlPopup(cible, url, tcible, mcible, rcible, dlcible);
            return false;
        });

        $('.cover_content').click(function(){

            var iframecible = $(this).next('.vid_content').find('iframe');
            var iframesrc = iframecible.data('src');


            if(iframecible.attr('src') == ''){
                $(iframecible).attr('src', iframesrc);
            }
            $(this).next('.vid_content').addClass('active');
        });

        $('#croissance .cover a').click(function(e) {
            setTimeout(function() {

                document.querySelector('.bicon-twitter').addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var hash = top.location.href.split('#');
                    var url = top.location.href;
                    if(typeof hash !== 'undefined' && hash !== null && hash.length > 0) {
                        url = top.location.origin + top.location.pathname + '?page=' + hash[1];
                    }
                    window.open('https://twitter.com/home?status=' + url);
                    return false;
                });

            }, 1000);
        });

        document.querySelector('.abs_contain .bicon-twitter').addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var hash = top.location.href.split('#');
            var url = top.location.href;
            if(typeof hash !== 'undefined' && hash !== null && hash.length > 0) {
                url = top.location.origin + top.location.pathname + '?page=engagement';
            }
            window.open('https://twitter.com/home?status=' + url);
            return false;
        });

    };

    function launchUrlPopup(cible, url, tcible, mcible, rcible, dlcible){

        // chgt image popin en fonction du device
        var responsivecible = cible;

        if (device == 'tablet')
        {
            responsivecible = tcible;
        }

        if (device == 'mobile')
        {
            responsivecible = mcible;
        }

        var siteurl = window.location.href;
        siteurl = siteurl.replace('#', '%23');
        var fblink = 'https://www.facebook.com/sharer/sharer.php?u='+siteurl;
        var twlink = 'https://twitter.com/home?status='+siteurl;
        var inlink = 'https://www.linkedin.com/shareArticle?mini=true&url='+siteurl+'&title=&summary=&source=';

        $.magnificPopup.open({
            items: {
                src: responsivecible,
                type : 'image'
            },
            image: {
                markup: '<div class="mfp-figure">'+
                '<div class="social_link"><div class="content">'+
                '<a target="_blank" href="'+inlink+'"><span class="bicon bicon-linkedin2"></span></a>'+
                '<a target="_blank" href="'+fblink+'"><span class="bicon bicon-facebook"></span></a>'+
                '<a target="_blank" href="'+twlink+'"><span class="bicon bicon-twitter"></span></a>'+
                '<a target="_blank" href="'+dlcible+'"><span class="bicon bicon-dl"></span></a>'+
                '</div></div>'+
                '<div class="mfp-close"></div>'+
                '<div class="mfp-img"></div>'+
                '<div class="mfp-bottom-bar">'+
                '<div class="mfp-title"></div>'+
                '<div class="mfp-counter"></div>'+
                '</div>'+
                '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
                cursor: 'null', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.
                verticalFit: false, // Fits image in area vertically
            },
            callbacks: {
                open: function() {
                    window.location.hash = url;
                },
                close: function() {
                    window.location.hash = rcible;
                }
            }
        });
    }

    return {
        init: init
    }
})();